import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DonationProvider } from './contexts/DonationContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home/Home';
import Causes from './pages/Causes/Causes';
import Events from './pages/Events/Events';
import Gallery from './pages/Gallery/Gallery';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Team from './pages/Team/Team';
import Volunteers from './pages/Volunteers/Volunteers';
import Services from './pages/Services/Services';
import News from './pages/News/News';
import HowToDonate from './pages/HowToDonate/HowToDonate';
import DonationList from './pages/DonationList/DonationList';
import FAQ from './pages/FAQ/FAQ';
import DonateAnonymous from './pages/DonateAnonymous/DonateAnonymous';
import DonateRegister from './pages/DonateRegister/DonateRegister';
import DonateLogin from './pages/DonateLogin/DonateLogin';
import Activate from './pages/Activate/Activate';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import Dashboard from './pages/Dashboard/Dashboard';
import Manjushree from './pages/Manjushree/Manjushree';
import ComingSoon from './pages/ComingSoon/ComingSoon';
import NotFound from './pages/NotFound/NotFound';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import './i18n/config';
import './App.css';

function App() {
  return (
    <DonationProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/coming-soon" element={<ComingSoon />} />
              <Route path="/causes" element={<Causes />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/volunteers" element={<Volunteers />} />
              <Route path="/services" element={<Services />} />
              <Route path="/news" element={<News />} />
              <Route path="/how-to-donate" element={<HowToDonate />} />
              <Route path="/donation-list" element={<DonationList />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/manjushree" element={<Manjushree />} />
              <Route path="/donate-anonymously" element={<DonateAnonymous />} />
              <Route path="/register" element={<DonateRegister />} />
              <Route path="/login" element={<DonateLogin />} />
              <Route path="/activate" element={<Activate />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              {/* Catch-all route for 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </DonationProvider>
  );
}

export default App;

